<template>
  <div class="wrapper">
    <div class="clearfix tab-header-panel">
      <div class="btn-container">
        <div class="viewAll">
          <i @click="_viewAll">{{ $t('viewAll') }}</i>
        </div>
        <div class="fillSpace" />
        <div class="btn-with-hint">
          <div
            v-if="!isEngineer"
            class="hints"
          >
            <div>{{ $t(`termsAndConditions.${regionName}.workPermit.hintForEdinburghTower`,[ $t('workPermit.types.WORK'), 5 ]) }}</div>
            <div>{{ $t(`termsAndConditions.${regionName}.workPermit.hintForOthers`,[ $t('workPermit.types.WORK'), 3 ]) }}</div>
          </div>
          <button
            v-if="!isEngineer"
            class="btn--orange"
            @click="() => applySAWorkPermit()"
          > {{ $t('standaloneWorkPermits.applySAWorkPermit') }} </button>
        </div>
      </div>
    </div>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr>
            <th><!-- placeholder --></th>
            <th
              v-for="(header, index) in itemHeaders"
              :key="index"
              :class="header.class"
              @click="sortBy(header.code)"
            >
              {{ header.name }}
            </th>
          </tr>
        </thead>
        <WorkPermitTableBody
          :items="items"
          :showActive="showActive"
          :tenancyTabIndex="tenancyTabIndex"
        />
      </table>
    </div>

    <Modal
      ref="applyStandaloneWPModal"
      modalId="apply-standalone-workpermits-modal"
      :showCloseBtn="false"
    >
      <div
        slot="content"
        class="modal-pure-text popup"
      >
        {{ $t('standaloneWorkPermits.text') }}<br><br>{{ $t('standaloneWorkPermits.applyProceedText') }}
      </div>
      <div slot="btns">
        <button
          id="confirm_no"
          type="button"
          class="btn btn--darkblue"
          @click="closeApplyStandaloneWPModal()"
        >{{ $t('action.cancel') }}</button>
        <button
          id="confirm_yes"
          type="button"
          class="btn btn--orange"
          @click="createStandaloneWp()"
        >{{ $t('action.confirm') }}</button>
      </div>
    </Modal>
    <SAWorkPermitTnC
      ref="saWpTnCModal"
      okBtnAction="accept"
      :companyName="selectedTrCompanyName"
      @onOkClick="openApplyStandaloneWPModal"
    />
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import lodash, {get} from 'lodash'
import { unref, computed, ref } from 'vue-demi'
import dateUtil from '@/utils/dateUtil'
import Modal from '@/controls/Modal'
import WorkPermitTableBody from '@/modules/workPermits/WorkPermitTableBody'
import {WORK_PERMIT_TYPES} from '@/modules/workPermits/consts'
import navigation from '@/utils/navigation'
import { createWorkPermit } from '@/api/workPermit/request'
import { standaloneWpRouteNames } from '@/utils/consts'
import { useRefModal } from '@/controls/Modal/modal.hook'
import SAWorkPermitTnC from '@/modules/workPermits/SAWorkPermitTnC.vue'
import { useStoreGetters } from '@/store/index'
import { useSaWpTnC } from '@/modules/workPermits/hooks/useTnC'
import { orderByPermitCode } from '@/utils/sortingHelper'

export default {
  name: 'TenancyStandaloneWorkPermits',
  components: {
    Modal,
    SAWorkPermitTnC,
    WorkPermitTableBody,
  },
  beforeRouteEnter (to, from, next) {
    next(vm => vm.setFromPage(from.name))
  },
  props: {
    tenancyTabIndex: {
      type: Number,
      default: 0,
    },
  },
  setup () {
    const { currentTenancy } = useStoreGetters('ccd', ['currentTenancy'])
    const { modal: saWpTnCModal, open: openSaWpTncModal } = useRefModal()
    const { hasSaWpTnC } = useSaWpTnC()
    const selectedTrCompanyName = computed(() => {
      const curTrVal = unref(currentTenancy)
      if (curTrVal) {
        return lodash.get(curTrVal, 'company.name', '')
      }
      return null
    })
    const applyStandaloneWPModal = ref(null)
    const applySAWorkPermit = () => {
      if (unref(hasSaWpTnC)) {
        openSaWpTncModal()
      } else {
        unref(applyStandaloneWPModal).open()
      }
    }
    return {
      applyStandaloneWPModal,
      selectedTrCompanyName,
      saWpTnCModal,
      applySAWorkPermit,
    }
  },
  data () {
    return {
      reverse: 0,
      reverseAll: 0,
      orderAllByAttr: 'disabled',
      dateUtil,
      showActive: true,
      fromPage: '',
    }
  },
  computed: {
    ...mapGetters('ccd', ['currentTenancy']),
    ...mapGetters('workPermit', ['workPermitsInTenancy']),
    ...mapGetters('user', ['currentUser', 'isTenant', 'isEngineer']),
    ...mapGetters('regions', ['regionName']),
    itemHeaders () {
      return [{
        code: 'type',
        name: this.$t('workPermit.type'),
      }, {
        code: 'workPermitNo',
        name: this.$t('workPermit.number'),
      }, {
        code: 'workDescription',
        name: this.$t('workPermit.description'),
      }, {
        code: 'status',
        name: this.$t('status.name'),
      }, {
        code: 'building',
        name: this.$t('workPermit.building'),
      }, {
        code: 'floor',
        name: this.$t('workPermit.floor'),
      }, {
        code: 'contractor',
        name: this.$t('workPermit.contractor'),
      }, {
        code: 'duration',
        name: this.$t('workPermit.duration'),
      }]
    },
    items () {
      return this.workPermitsInTenancy.map(item => {
        return {
          ...item.self,
          tenancy: {...get(item, 'self.tenancy', {}), accounts: this.currentTenancy.accounts},
          hoistings: orderByPermitCode(item.hoistings),
          collapsed: false,
        }
      })
    },
  },

  mounted () {
    if (this.$router.currentRoute.params.id) {
      this.getAllWorkPermitsByTenantId({ sourceId: this.$router.currentRoute.params.id })
    }
  },
  methods: {
    ...mapActions('workPermit',
      ['getAllWorkPermitsByTenantId']),
    sortBy (attr) {
      if (this.orderbyAttr === attr) {
        this.reverse = !this.reverse
      }
      this.orderbyAttr = attr
    },
    sortAllBy (attr) {
      if (this.orderAllByAttr === attr) {
        this.reverseAll = !this.reverseAll
      }
      this.orderAllByAttr = attr
    },
    closeApplyStandaloneWPModal () {
      this.$refs['applyStandaloneWPModal'].close()
    },
    openApplyStandaloneWPModal () {
      this.$refs['applyStandaloneWPModal'].open()
    },
    async createStandaloneWp () {
      let contractor = this.currentTenancy.tenancyContractors.find(item => item.userId === this.currentUser.id)
      const workpermit = await createWorkPermit({
        contractorId: contractor ? contractor.contractorId : null,
        isTenantProject: this.isTenant,
        type: WORK_PERMIT_TYPES.WORK,
        standalone: true,
        sourceId: this.$router.currentRoute.params.id,
      })
      if (workpermit) {
        this.gotoCreatePage(workpermit)
      }
    },
    gotoCreatePage (item) {
      navigation.toPage(standaloneWpRouteNames.tenantStandaloneWp, { id: item.id })
    },
    _viewAll () {
      this.showActive = false
    },
    setFromPage (name) {
      this.fromPage = name
    },
  },
}
</script>

<style lang="scss" scoped>
  @import '~styles/tender/view';
  @import '~styles/icon_remove';
  @import '~styles/_settings.scss';
  @import '~styles/popup';

  .table-caption {
    text-align: left;
    font-size: 16px;
    padding-left: 0px;
    font-weight: 700;
    margin-bottom: 15px;
  }
  .disable-checkbox {
    border: 1px solid grey;
    background-color: #d8d8d8;
    cursor: not-allowed;
  }

  .checkbox {
    cursor: pointer;
    cursor: hand;
  }

  .tab-header-panel {
    padding: 0px 0px 15px;
  }

  .btn-container {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
  }
.btn-with-hint {
  display: flex;
  align-items: center;
  .hints {
    display: inline-block;
    color: #E49405;
    margin-right: 15px;
    // to override h4 font-family: Georgia; no idea why spacial font-families are in datatable
    font-size: 14px;
    font-family: $content-font-family;
    line-height: 20px;
    text-align: right;
  }
}
    .viewAll {
      i {
        text-align:right;
        cursor: pointer;
        text-decoration: underline;
        color: #0C3A58;
        font-size: 12px;
        font-weight: 700;
        font-style: normal;
      }
    }

  .fillSpace {
    flex: 1
  }

  .popup {
    white-space: pre-line
  }
</style>
